export default "__VITE_ASSET__DRr2pZw4__"